import { createLimitTransaction } from "@/actions/db/credit-transaction";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useCreditBalance } from "@/hooks/providers/credit-balance-provider";
import {
  showNotEnoughCreditsError,
  showPurchaseSuccessfulNotification,
  showUnknownPurchaseError,
} from "@/utils/notification-helper";
import { NotEnoughCreditsError } from "@/errors/not-enough-credits-error";
import { useLoggingContext } from "@/providers/logging-provider/logging-provider";

export const useLimitTransaction = () => {
  const { hideModal } = useGlobalModalContext();
  const { handleCreditTransaction } = useCreditBalance();
  const logger = useLoggingContext();

  const buyConvertLimit = async () => {
    await createLimitTransaction(1, "CONVERT");
  };

  const buyCustomVoiceLimit = async () => {
    await createLimitTransaction(1, "CUSTOM_VOICE");
  };

  const handleUseCreditsClick = async (
    transaction: () => Promise<void>,
    priceInCredits: number,
  ) => {
    try {
      await handleCreditTransaction(transaction, priceInCredits);
      showPurchaseSuccessfulNotification();
    } catch (err) {
      if (err instanceof NotEnoughCreditsError) {
        showNotEnoughCreditsError();
      } else {
        showUnknownPurchaseError();
        logger.logError(err as Error);
      }
    } finally {
      hideModal();
    }
  };

  return {
    buyConvertLimit,
    buyCustomVoiceLimit,
    handleUseCreditsClick,
  };
};
